import { render, staticRenderFns } from "./trademark.vue?vue&type=template&id=74be50ea&scoped=true&"
import script from "./trademark.vue?vue&type=script&lang=js&"
export * from "./trademark.vue?vue&type=script&lang=js&"
import style0 from "./trademark.vue?vue&type=style&index=0&id=74be50ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74be50ea",
  null
  
)

export default component.exports